import { ReferenceContext } from "providers/ReferenceProvider";
import styles from "./contact.module.scss";
import Description from "primitives/Description";

const Contact = () => {
  const d = new Date();
  const currentYear = d.getFullYear();

  return (
    <ReferenceContext.Consumer>
      {(refs) => (
        <div className={styles.container} ref={refs.contactRef}>
          <div className={styles.info_container}>
            <Description>
              Github -{" "}
              <a
                href={"https://github.com/stevenhgn"}
                className={styles.anchor}
              >
                stevenhgn
              </a>
            </Description>
            <Description>
              LinkedIn -{" "}
              <a
                href={"https://www.linkedin.com/in/steven-n-895487144/"}
                className={styles.anchor}
              >
                Steven Nguyen
              </a>
            </Description>
            <small className={styles.copyRightText}>
              &copy; Copyright {currentYear} Steven Nguyen
            </small>
          </div>
        </div>
      )}
    </ReferenceContext.Consumer>
  );
};

export default Contact;
